import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\",\"cyrillic\"],\"display\":\"optional\",\"preload\":false}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["DeferredClientChrome"] */ "/app/src/components/DeferredClientChrome.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AnimationProvider"] */ "/app/src/contexts/AnimationContext.tsx");
